import { AboutUsDescription, Mission, Plan, Vision } from "../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faBullseye, faTasks } from "@fortawesome/free-solid-svg-icons";
import "../../img/about-bg.jpg";

const AboutUs: React.FC<{}> = () => {
  return (
    <div>
      {" "}
      <section id="about">
        <div className="container">
          <header className="section-header">
            <h3>About Us</h3>
            <p>{AboutUsDescription}</p>
          </header>

          <div className="row about-cols">
            <div className="col-md-4 wow fadeInUp">
              <div className="about-col">
                <div className="img">
                  <img
                    src="../../img/about-bg.jpg"
                    alt=""
                    className="img-fluid"
                  />
                  <div className="icon">
                    <FontAwesomeIcon icon={faBullseye} size="3x" />
                  </div>
                </div>
                <h2 className="title">Our Mission</h2>
                <p>{Mission}</p>
              </div>
            </div>

            <div className="col-md-4 wow fadeInUp" data-wow-delay="0.1s">
              <div className="about-col">
                <div className="img">
                  <img src="img/about-plan.jpg" alt="" className="img-fluid" />
                  <div className="icon">
                    <FontAwesomeIcon icon={faEye} size="3x" />
                  </div>
                </div>
                <h2 className="title">Our Plan</h2>
                <p>{Plan}</p>
              </div>
            </div>

            <div className="col-md-4 wow fadeInUp" data-wow-delay="0.2s">
              <div className="about-col">
                <div className="img">
                  <img
                    src="img/about-vision.jpg"
                    alt=""
                    className="img-fluid"
                  />
                  <div className="icon">
                    <FontAwesomeIcon icon={faTasks} size="3x" />
                  </div>
                </div>
                <h2 className="title">Our Vision</h2>
                <p>{Vision}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
